import { createSlice } from "@reduxjs/toolkit";
import type { IContentState } from "./Content.types";

const initialState: IContentState = {};

const contentSlice = createSlice({
  name: "content",
  initialState,
  reducers: {},
});

export default contentSlice.reducer;
